import React from 'react'
import {
  InformfixService,
  HomeService,
  ProjectService,
  AuthService,
  JobService,
} from './../../../services'
import {
  List,
  Avatar,
  Button,
  Skeleton,
  Modal,
  Select,
  Row,
  Col,
  Input,
  message,
  Dropdown,
  Menu,
  Popconfirm,
  Form,
  Card,
  PageHeader,
  Divider,
  notification,
  Tooltip,
  Space,
  Spin,
  DatePicker,
} from 'antd'
import { Config } from './../../../config/index'
import iconHome from '../../../assets/images/informfix/icon-home.png'
import './style.scss'
import PaginationDetail from '../../PaginationDetail'
import queryString from 'query-string'
import { Moment } from '../../../helpers'
import { observer, inject } from 'mobx-react'
import InformView from './../inform-view'
import InformFormAdd from './../inform-form'
import InformEdit from './../inform-edit'
import AssignJob from './../assign-job'
import NotificationAdd from './../../../components/notification/notification-form'
import { InformfixStatus } from '../InformfixStatus'
import {
  PlusCircleOutlined,
  SearchOutlined,
  ReloadOutlined,
  CalendarFilled,
  EditFilled,
  UserOutlined,
  FileDoneOutlined,
  BellOutlined,
} from '@ant-design/icons'

const IconText = ({ text, icon }) => (
  <div style={{ margin: 2 }}>
    {icon} {text}
  </div>
)

const { Option } = Select
const formatDateSearch = 'DD/MM/YYYY'
const openNotificationWithIcon = (type, message, description = '') => {
  notification[type]({
    message: message ? message : 'Notification Title',
    description: description,
  })
}

@inject('informStore')
@observer
class InformCard extends React.Component {
  constructor() {
    super()
    this.state = {
      initLoading: true,
      loading: false,
      loadingProject: false,
      data: [],
      list: [],
      showFormAdd: false,
      showFormEdit: false,
      showFormAssign: false,
      showFormNotification: false,
      editId: '',
      viewId: '',
      searchParams: {
        project_id: '',
        work_status: '',
        q: '',
        f: 'id',
      },
      pagination: {
        current: 1,
        total: 0,
        pageSize: Config.pager.limit,
        pageCount: 0,
      },
      homeDetail: {},
      inform: {},
      galleries: [],
      photos: [],
      visibleHomeDetail: false,
      confirmLoading: false,
      projects: [{ id: 1, name: 'noom' }],
      listStatus: [],
      listJobStatus: [],
      formStep: 0,
    }
  }

  formRef = React.createRef()

  setPageParams(params) {
    this.setState({
      pagination: {
        current: params.currentPage,
        total: params.totalCount,
        pageSize: params.perPage,
        pageCount: params.pageCount,
      },
    })
  }

  /**
   * แสดงข้อมูลตาม Filter ที่เลือกไว้
   */
  getData = () => {
    const params = {
      page: this.state.pagination ? this.state.pagination.current : 1,
      'per-page': this.state.pagination
        ? this.state.pagination.pageSize
        : Config.pager.limit,
      project_id: this.state.searchParams.project_id,
      work_status: this.state.searchParams.work_status,
      f: this.state.searchParams.f,
      q: this.state.searchParams.q,
    }
    this.setState({
      pagination: {
        current: 1,
        total: 0,
        pageSize: Config.pager.limit,
        pageCount: 0,
      },
    })
    return InformfixService.search(params)
  }

  /**
   * ดึงข้อมุลใบแจ้งซ๋อมแบบเริ่มที่หน้า 1 และรีเซ็ต Filter ใหม่หมด
   */
  getItems = () => {
    const pagination = { ...this.state.pagination }
    pagination.current = 1
    pagination.total = 0
    pagination.pageSize = Config.pager.limit
    pagination.pageCount = 0
    this.setState({
      initLoading: true,
    })
    this.state.pagination.current = 1
    this.getData()
      .then((rs) => {
        const data = rs.data['items']
        const pager = rs.data['_meta']
        this.setPageParams(pager)

        this.setState(
          {
            data: data,
            list: data,
            initLoading: false,
          },
          () => {
            window.dispatchEvent(new Event('resize'))
          },
        )
        this.props.informStore.setItems(this.state.list)
      })
      .catch((err) => {
        if (err.response) {
          const code = err.response.status
          console.log(err.response)
          if (code === 404) {
            message.warning(err.response.statusText)
          }
        }
        this.setState({ initLoading: false })
      })
  }
  /**
   * สำหรับปุ่มค้นหาแสดงเริ่มต้นที่หน้า 1 และ filter อื่น ๆ ยังคง filter อื่น ๆ ไว้
   */
  onSearch = () => {
    this.setState({
      list: [],
    })
    // this.forceUpdate();
    this.getItems()
    // this.setQueryString();
  }
  
  /**
   * ปุ่มโหลดข้อมูลเพิ่ม แสดงข้อมูลเรือยๆ จนกว่าจะหมด
   */
  onLoadMore = () => {
    // this.setQueryString();
    const count = this.state.pagination.total
    if (this.state.pagination.current < this.state.pagination.pageCount) {
      this.state.pagination.current = this.state.pagination.current + 1
      this.getData()
        .then((rs) => {
          const data = this.state.data.concat(rs.data['items'])
          const pager = rs.data['_meta']
          this.setPageParams(pager)
          this.setState(
            {
              data,
              list: data,
              loading: false,
            },
            () => {
              window.dispatchEvent(new Event('resize'))
            },
          )
          this.props.informStore.setItems(this.state.list)
        })
        .catch((err) => {
          message.warning('Not found.')
          this.setState({
            initLoading: false,
            loading: false,
          })
        })
    }
  }

  /**
   * ข้อมูลสถานะแจ้งซ่อมทั้งหมด
   */
  getWorkStatus() {
    InformfixService.getWorkStatus().then((rs) => {
      if (rs) {
        const data = rs.data['data']
        this.setState({ listStatus: data })
      }
    })
  }
  /**
   * ข้อมูลสถานะคิวงานแจ้งซ่อม
   */
  getJobStatus() {
    JobService.getJobStatus().then((rs) => {
      if (rs) {
        const data = rs.data['data']
        this.setState({ listJobStatus: data })
      }
    })
  }

  /**
   * ข้อมูลโครงการทั้งหมด
   */
  getProjects() {
    this.setState({
      loadingProject: true,
    })
    ProjectService.all().then((pj) => {
      if (pj) {
        const dataProject = pj.data['data']
        this.setState({ projects: dataProject })
        this.setState({
          loadingProject: false,
        })
        // this.getData().then((rs) => {
        //   const data = rs.data['items']
        //   const pager = rs.data['_meta']
        //   this.setState({
        //     initLoading: false,
        //     data: data,
        //     list: data,
        //   })
        //   this.setPageParams(pager)
        // })
      }
    })
  }

  componentDidMount() {
    // ดึงรายชื่อโครงการทั้งหมดมาตอนเปิดหน้าครั้งแรก
    this.getProjects()

    // โหลดข้อมูลสถานะใบแจ้งซ่อม
    this.getWorkStatus()

    // โหลดข้อมูลสถานะคิวงานทั้งหมด
    this.getJobStatus()
    const qry = queryString.parse(this.props.location.search)
    let searchParams = this.state.searchParams

    if (qry.project_id) {
      searchParams.project_id = qry.project_id
      this.formRef.current.setFieldsValue({
        project_id: qry.project_id,
      })
    }

    if (qry.work_status) {
      searchParams.work_status = qry.work_status
      this.formRef.current.setFieldsValue({
        work_status: qry.work_status,
      })
    }

    if (qry.f) {
      searchParams.f = qry.f
      this.formRef.current.setFieldsValue({
        f: qry.f,
      })
    }
    if (qry.f == 'date') {
      searchParams.q = qry.q
      if (qry.q) {
        this.formRef.current.setFieldsValue({
          q: Moment(qry.q).utc(7),
        })
      }
    } else {
      searchParams.q = qry.q
      this.formRef.current.setFieldsValue({
        q: qry.q,
      })
    }
    this.setState({
      searchParams,
    })
    this.onSearch()
  }

  /**
   * แสดงแบบฟอร์มเพิ่มใชแจ้งซ่อม
   */
  showFormAdd = () => {
    this.setState({ showFormAdd: true })
  }

  /**
   * ซ่อนแบบฟอร์มเพิ่มใชแจ้งซ่อม
   */
  hideModalAdd = () => {
    this.setState({ showFormAdd: false })
  }

  getInform(item) {
    this.props.informStore.setItem({})
    this.props.informStore.setJobItems([])
    this.props.informStore.setJob({})

    // รูปภาพต่าง ๆ
    InformfixService.getGallery(item.id).then((gallery) => {
      this.setState({ photos: gallery })
      this.props.informStore.setGalleryItems(gallery)
    })

    // ข้อมูบใบแจ้งซ่อม
    InformfixService.view(item.id).then((inform) => {
      this.setState({
        inform: inform.data['data'],
      })
      this.props.informStore.setItem(this.state.inform)
    })

    // ข้อมูลบ้าน
    if (item.home) {
      HomeService.view(item.home.id).then((home) => {
        this.setState({
          visibleHomeDetail: true,
          homeDetail: home.data.data,
        })
        this.props.informStore.setHome(this.state.homeDetail)
      })
    }

    // jobs
    InformfixService.getJobs(item.id).then((rs) => {
      this.setState({
        informJobs: rs.data.data,
      })
    })
  }

  /**
   * ดูรายละเอียดใบแจ้งซ่อม
   */
  showModalView = (item) => {
    this.props.informStore.setItem({})
    this.props.informStore.setJobItems([])
    this.props.informStore.setJob({})
    this.setState({
      showFormView: true,
      homeDetail: {},
    })
    this.getInform(item)
  }

  /**
   * แสดงแบบฟอร์มแก้ไขข้มูลใบแจ้งซ่อม
   */
  showModalEdit = (item, step = 0) => {
    this.props.informStore.setItem({})
    this.props.informStore.setJobItems([])
    this.props.informStore.setJob({})

    this.setState({
      editId: item.id,
      formStep: step,
    })
    InformfixService.view(item.id).then((inform) => {
      this.setState({
        inform: inform.data['data'],
        showFormEdit: true,
      })
      this.props.informStore.setItem(inform.data['data'])
    })
  }
  /**
   * ซ่อนหน้าดูรายละเอียดใบแจ้งซ่อม
   */
  hideModalView = (e) => {
    this.props.informStore.setItem({})
    this.props.informStore.setJobItems([])
    this.props.informStore.setJob({})
    this.setState({
      showFormView: false,
      homeDetail: {},
      galleries: [],
    })
  }

  /**
   * ซ่อนแบบฟอร์มแก้ไขใบแจ้งซ่อม
   */
  hideModalEdit = () => {
    this.props.informStore.setItem({})
    this.props.informStore.setJobItems([])
    this.props.informStore.setJob({})
    this.setState({
      showFormEdit: false,
      editId: '',
      inform: {},
    })
    this.props.informStore.setEditId('')
  }

  /**
   * แสดงแบบฟอร์มจัดตารางคิวงาน
   */
  showModalAssign = (item) => {
    this.setState({
      showFormAssign: true,
      editId: item.id,
      inform: item,
    })
    this.props.informStore.setEditId(item.id)
    this.props.informStore.setItem(item)
  }

  hideModalAssign = () => {
    this.props.informStore.setItem({})
    this.props.informStore.setJobItems([])
    this.props.informStore.setJob({})
    this.setState({
      showFormAssign: false,
      editId: '',
    })
    this.props.informStore.setEditId('')
  }

  /**
   * แบบฟอร์สราการแจ้งเตือนเลื่อนนัด
   */
  showModalNotification = (item) => {
    this.setState({
      showFormNotification: true,
      editId: item.id,
    })
    console.log('show form notification')
  }

  hideModalNotification = () => {
    console.log('hideModalNotification')
    this.setState({
      showFormNotification: false,
      editId: '',
    })
    this.props.informStore.setEditId('')
  }
  onChangeProject = (value) => {
    let searchParams = this.state.searchParams
    searchParams.project_id = value
    this.setState({
      searchParams,
    })
    this.setQueryString()
  }
  onChangeWorkStatus = (value) => {
    let searchParams = this.state.searchParams
    searchParams.work_status = value
    this.setState({
      searchParams,
    })
    this.setQueryString()
  }
  onChangeSearchFeild = (value) => {
    this.formRef.current.setFieldsValue({
      q: null,
    })
    let searchParams = this.state.searchParams
    searchParams.f = value
    const nowDate = Moment()
      .utc(7)
      .format('YYYY-MM-DD')
    if (value == 'date') {
      searchParams.q = null
      this.formRef.current.setFieldsValue({
        q: null,
      })
    } else {
      searchParams.q = null
    }
    this.setState({
      searchParams,
    })
    this.setQueryString()
  }

  onChangeQ = (e) => {
    e.persist()
    let searchParams = this.state.searchParams
    if (searchParams.f == 'date') {
    } else {
      searchParams.q = e.target.value
    }
    this.setState({
      searchParams,
    })
    this.setQueryString()
  }
  onChangDate = (value) => {
    let searchParams = this.state.searchParams
    const date = Moment(value)
      .utc(7)
      .format('YYYY-MM-DD')
    console.log('date', date)
    if (Moment(value).isValid()) {
      searchParams.q = date
    } else {
      searchParams.q = null
    }
    this.setState({
      searchParams,
    })
    this.setQueryString()
  }

  /**
   * เปลี่ยนสถานะใบแจ้งซ่อม
   */
  setWorkStatus = (item, status) => {
    if (status.value != undefined) {
      this.setQueryString()
      InformfixService.setWorkStatus(item.id, {
        workstatus: status.value,
      }).then((rs) => {
        const data = rs.data.data
        const { list } = this.state
        const index = list.indexOf(item)
        list[index] = data
        this.setState({
          list,
        })
        openNotificationWithIcon('success', rs.data.message)
      })
    }
  }

  setQueryString() {
    let params = queryString.stringify(this.state.searchParams)
    this.props.history.push({
      search: params,
    })
  }

  resetForm() {
    this.formRef.current.resetFields()
    this.setState({
      data: [],
      list: [],
      searchParams: {
        project_id: '',
        work_status: '',
        q: '',
        f: 'plan_no',
      },
      pagination: {
        current: 1,
        total: 0,
        pageSize: this.state.pagination.perPage,
        pageCount: 0,
      },
    })
    const { form } = this.props
    this.onSearch()
  }

  cancelInform = (item) => {
    InformfixService.cancel(item.id).then((rs) => {
      if (rs) {
        const data = rs.data['data']
        const { list } = this.state
        const index = list.indexOf(item)
        list[index] = data
        this.setState({
          list,
        })
        message.success(rs.data['message'])
      }
    })
    return false
  }

  render() {
    const { informStore } = this.props
    const {
      initLoading,
      loading,
      loadingProject,
      pagination,
      homeDetail,
      inform,
      projects,
      listStatus,
      searchParams,
      photos,
    } = this.state

    const loadMore =
      !initLoading &&
      !loading &&
      pagination &&
      pagination.current < pagination.pageCount ? (
        <div
          style={{
            textAlign: 'center',
            marginTop: 12,
            height: 32,
            lineHeight: '32px',
          }}
        >
          <Button
            type={Config.button.loadMore.type}
            block={Config.button.loadMore.block}
            shape={Config.button.loadMore.shape}
            onClick={this.onLoadMore}
            loading={loading}
          >
            {Config.button.loadMore.text}
          </Button>
          {''}
        </div>
      ) : null

    const WORK_STATUS_COLOR = (item) => {
      return item.work_status
        ? Config.informfix.workStatus[item.work_status].color
        : ''
    }

    const WORK_STATUS_BACKGROUND = (item) => {
      return item.work_status
        ? Config.informfix.workStatus[item.work_status].background
        : ''
    }

    const IMAGE_FEATHURS = (item) =>
      item.cover ? (
        <img
          src={item.cover.thumbnail}
          onClick={() => this.showModalView(item)}
          style={{
            width: '100%',
            height: 200,
            cursor: 'pointer',
          }}
        />
      ) : (
        <img
          src={iconHome}
          onClick={() => this.showModalView(item)}
          style={{
            width: '100%',
            height: 200,
            cursor: 'pointer',
            filter: 'grayscale(100%)',
            WebkitFilter: 'grayscale(100%)',
          }}
        />
      )

    const qry = queryString.parse(this.props.location.search)

    const CanEdit = (item) => {
      return item.work_status.toString() !== '3' ? true : false
    }

    const CanCancel = (item) => {
      return item.work_status.toString() == '1' ? true : false
    }
    const CanAssignJob = (item) => {
      return item.work_status.toString() !== '3' ? true : false
    }

    const menuChangeStatus = (item) => {
      return (
        <Tooltip title="เปลี่ยนสถานะ">
          <Dropdown.Button
            key={item.subject}
            size="small"
            shape="round"
            overlay={
              <Menu key={item.id}>
                {listStatus.map((status, statusKey) => (
                  <Menu.Item key={statusKey}>
                    <div onClick={() => this.setWorkStatus(item, status)}>
                      {status.value}) {status.text}
                    </div>
                  </Menu.Item>
                ))}
              </Menu>
            }
          >
            เปลี่ยนสถานะ
          </Dropdown.Button>
        </Tooltip>
      )
    }
    const menuActionItem = (item) => {
      return (
        <Menu key={'vvv' + item.id}>
          <Menu.Item
            onClick={() => this.showModalEdit(item)}
            style={{ display: !CanEdit(item) ? 'none' : null }}
          >
            <EditFilled /> แก้ไข
          </Menu.Item>
          <Menu.Item
            title="เลือนนัด"
            key={'btnpostnone' + item.id}
            type="light"
            onClick={() => this.showModalNotification(item)}
            style={
              {
                // display: !CanEdit(item) ? 'none' : '',
              }
            }
          >
            <ReloadOutlined /> แจ้งเลื่อนนัด
          </Menu.Item>
        </Menu>
      )
    }

    const showMenuAction = (item) => {
      return (
        <Dropdown.Button
          size="small"
          key={'dddd' + item.id}
          overlay={menuActionItem(item)}
          trigger={['click']}
        >
          จัดการ
        </Dropdown.Button>
      )
    }
    
    return (
      <React.Fragment>
        <PageHeader title="ใบแจ้งซ่อม">
          <Form
            ref={this.formRef}
            id="informfixForm"
            initialValues={{
              project_id: searchParams.project_id,
              q: searchParams.q,
              f: searchParams.f,
              work_status: searchParams.work_status,
            }}
          >
            <Row justify="space-between" gutter={{ xs: 3, sm: 3, md: 3 }}>
              <Col
                xs={{ span: 24 }}
                sm={{ span: 24 }}
                md={{ span: 6 }}
                lg={{ span: 5 }}
              >
                <Form.Item name="project_id">
                  <Select
                    loading={loadingProject}
                    key="dropdown-project"
                    showSearch
                    allowClear
                    style={{ width: '100%' }}
                    placeholder="-เลือกโครงการ-"
                    optionFilterProp="children"
                    onChange={this.onChangeProject}
                    filterOption={(input, option) =>
                      option.props.children
                        .toLowerCase()
                        .indexOf(input.toLowerCase()) >= 0
                    }
                  >
                    {projects.map((p, index) => (
                      <Option key={p.id} value={p.id}>
                        {p.name}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>
              <Col
                xs={{ span: 24 }}
                sm={{ span: 24 }}
                md={{ span: 5 }}
                lg={{ span: 3 }}
              >
                <Form.Item name="work_status">
                  <Select
                    placeholder="-เลือกสถานะ-"
                    style={{ width: '100%' }}
                    onChange={this.onChangeWorkStatus}
                    allowClear
                    optionLabelProp="label"
                  >
                    {listStatus.map((status, key) => (
                      <Option
                        key={key}
                        value={status.value}
                        label={status.text}
                      >
                        {status.text}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>
              <Col
                xs={{ span: 24 }}
                sm={{ span: 24 }}
                md={{ span: 4 }}
                lg={{ span: 4 }}
              >
                <Form.Item name="f">
                  <Select
                    placeholder="-ประเภทคำค้นหา-"
                    style={{ width: '100%' }}
                    onChange={this.onChangeSearchFeild}
                    allowClear
                  >
                    <Option value="date">วันที่แจ้ง</Option>
                    <Option value="home_no">บ้านเลขที่</Option>
                    <Option value="plan_no">แปลงบ้าน</Option>
                    <Option value="informer">ชื่อผู้แจ้ง</Option>
                    <Option value="id">ID</Option>
                  </Select>
                </Form.Item>
              </Col>
              <Col
                xs={{ span: 24 }}
                sm={{ span: 24 }}
                md={{ span: 5 }}
                lg={{ span: 5 }}
              >
                <Form.Item name="q">
                  {searchParams.f == 'date' ? (
                    <DatePicker
                      format={formatDateSearch}
                      onChange={this.onChangDate}
                      allowClear={true}
                    />
                  ) : (
                    <Input
                      placeholder="คำค้นหา.."
                      onChange={this.onChangeQ}
                      onPressEnter={this.onSearch}
                      allowClear
                    />
                  )}
                </Form.Item>
              </Col>
              <Col
                xs={{ span: 24 }}
                sm={{ span: 24 }}
                md={{ span: 24 }}
                lg={{ span: 4 }}
              >
                <Button
                  type="primary"
                  loading={loading || initLoading}
                  disabled={loading || initLoading}
                  shape="circle"
                  onClick={this.onSearch}
                  title="ค้นหา"
                  icon={<SearchOutlined />}
                ></Button>
                <Space /> <Space />
                <Button
                  type="light"
                  htmlType="reset"
                  className="submit"
                  onClick={() => this.resetForm()}
                  title="รีเซ็ตการค้นหา"
                  icon={<ReloadOutlined />}
                ></Button>
                <Space /> <Space />
                <Button
                  type="light"
                  onClick={() => this.showFormAdd()}
                  title="เพิ่มใบแจ้งซ่อม"
                  icon={<PlusCircleOutlined />}
                ></Button>
              </Col>
            </Row>
          </Form>
          {/* ///////////////////////////////////////// */}
          <PaginationDetail data={pagination} />
          <List
            grid={{
              gutter: 8,
              xs: 1,
              sm: 2,
              md: 2,
              lg: 4,
              xl: 4,
              xxl: 6,
            }}
            // itemLayout='vertical'
            size="small"
            loading={initLoading}
            loadMore={loadMore}
            dataSource={this.state.list}
            renderItem={(item) => (
              <List.Item
                className="inform-item"
                style={{
                  padding: 0,
                }}
                key={item.title}
                // actions={[
                //   CanEdit(item) ? (
                //     <Button
                //       icon={<BellOutlined />}
                //       size="small"
                //       onClick={() => this.showModalNotification(item)}
                //     >
                //       แจ้งเลื่อนนัด
                //     </Button>
                //   ) : null,
                // ]}
              >
                {!loading ? (
                  <Skeleton loading={loading}>
                    <div className="project">
                      {item.project ? item.project.name : '-ไม่ได้ระบุ-'}
                      <div>
                        <span>
                          {typeof item.home.home_no !== 'undefined' &&
                          item.home.home_no != null ? (
                            <span className="homeno">
                              {'เลขที่ ' + item.home.home_no}
                            </span>
                          ) : null}{' '}
                          {typeof item.home.plan_no !== 'undefined' &&
                          item.home.plan_no != null
                            ? '  แปลง ' + item.home.plan_no
                            : null}
                        </span>
                      </div>
                    </div>
                    {IMAGE_FEATHURS(item)}

                    <div
                      className="inform-item-overlay"
                      onClick={() => this.showModalView(item)}
                      style={{ cursor: 'pointer' }}
                    >
                      <div className="workstatus" align="center">
                        <InformfixStatus
                          name={item.workStatusName}
                          statusId={item.work_status}
                        />
                      </div>

                      <div>
                        <IconText
                          icon={<FileDoneOutlined />}
                          text={'เลขที่ใบแจ้งซ่อม#' + item.code}
                          style={{
                            display: 'block',
                            margin: 1,
                            fontSize: 11,
                            fontWeight: 'bolder',
                          }}
                        />
                        <IconText
                          icon={<FileDoneOutlined />}
                          text={'ID#' + item.id}
                          style={{
                            display: 'block',
                            margin: 1,
                            fontSize: 11,
                            fontWeight: 'bolder',
                          }}
                        />
                        <IconText
                          icon={<CalendarFilled />}
                          text={
                            typeof item.created_at === 'number'
                              ? Moment.unix(item.date_inform).format('lll')
                              : null
                          }
                          style={{
                            display: 'block',
                            margin: 1,
                            fontSize: 11,
                          }}
                        />

                        <IconText
                          icon={<UserOutlined />}
                          text={
                            item.informer ? item.informer : item.customer_name
                          }
                          style={{
                            display: 'block',
                            margin: 3,
                          }}
                        />
                      </div>
                    </div>

                    <div className="inform-content">
                      <h3
                        style={{
                          fontWeight: 'bolder',
                          textAlign: 'center',
                          cursor: 'pointer',
                        }}
                        onClick={() => this.showModalView(item)}
                      >
                        {item.subject ? item.subject : null}
                      </h3>

                      <p
                        style={{
                          textAlign: 'justify',
                          height: '100%',
                          display: 'block',
                          cursor: 'pointer',
                        }}
                        onClick={() => this.showModalView(item)}
                      >
                        {item.description ? item.description : null}
                      </p>
                    </div>
                  </Skeleton>
                ) : (
                  ''
                )}
              </List.Item>
            )}
          />
          <PaginationDetail data={pagination} />
        </PageHeader>

        {/* ////////////// START Modal VIEW /////////// */}
        <Modal
          key="modal-view"
          title="ดูรายละเอียดใบแจ้งซ่อม"
          bodyStyle={{
            padding: '7px',
            backgroundColor: '#222222',
            color: '#ffffff',
          }}
          width={960}
          open={this.state.showFormView}
          cancelText="ปิดหน้าต่าง"
          maskClosable
          style={{ top: 10 }}
          onCancel={this.hideModalView}
          footer=""
          destroyOnClose
        >
          {this.state.inform && this.state.showFormView ? (
            <InformView
              itemId={this.state.viewId}
              home={homeDetail}
              photos={photos}
              item={inform}
              jobs={this.state.informJobs}
              jobStatuses={this.state.listJobStatus}
              hideModal={this.hideModalView}
            />
          ) : (
            <Spin />
          )}
        </Modal>
        {/* ////////////// END Modal VIEW  /////////// */}
        {/* ////////////// START Modal Edit /////////// */}
        <Modal
          title="แก้ไขใบแจ้งซ่อม"
          open={this.state.showFormEdit}
          onCancel={this.hideModalEdit}
          footer=""
          bodyStyle={{
            padding: '10px',
          }}
          style={{ top: 5 }}
          destroyOnClose
        >
          {this.state.editId && this.state.showFormEdit ? (
            <InformEdit
              key={this.state.informfixId}
              informfixId={this.state.editId}
              item={this.state.inform}
              onUpdate={(data) => {
                const informfix = this.props.informStore.getItem
                const { list } = this.state
                if (informfix) {
                  list.map((i, index) => {
                    if (i.id == informfix.id) {
                      list[index] = informfix
                    }
                  })
                  this.setState({
                    list,
                  })
                }
              }}
              hideModal={() => {
                this.hideModalEdit()
              }}
              formStep={this.state.formStep ? this.state.formStep : 0}
            />
          ) : null}
        </Modal>
        {/* ////////////// END Modal Edit /////////// */}
        {/* ////////////// START Modal assign job /////////// */}
        <Modal
          open={this.state.showFormAssign}
          onCancel={this.hideModalAssign}
          footer=""
          bodyStyle={{
            padding: '7px',
          }}
          width="95%"
          centered
          destroyOnClose
          title={
            <Row>
              <Col
                xs={{ span: 24 }}
                sm={{ span: 24 }}
                md={{ span: 15 }}
                lg={{ span: 15 }}
              >
                <strong>{this.state.inform.subject}</strong>
              </Col>
              <Col
                xs={{ span: 24 }}
                sm={{ span: 24 }}
                md={{ span: 9 }}
                lg={{ span: 9 }}
              >
                {/* {showWorkStatus(this.state.inform)} */}
                <InformfixStatus
                  name={this.state.inform.workStatusName}
                  statusId={this.state.inform.work_status}
                />
              </Col>
            </Row>
          }
        >
          {this.state.showFormAssign ? (
            <AssignJob
              inform={this.state.inform}
              informfixId={this.state.editId}
              listStatus={this.listStatus}
            />
          ) : null}
        </Modal>
        {/* ////////////// END Modal assign job /////////// */}
        {/* ////////////// start Modal ADD /////////// */}
        <Modal
          title="เพิ่มใบแจ้งซ่อมใหม่"
          key="modal-add"
          open={this.state.showFormAdd}
          closable
          footer=""
          onCancel={() => this.hideModalAdd()}
          destroyOnClose
        >
          {this.state.showFormAdd ? (
            <InformFormAdd
              hideModal={() => this.hideModalAdd()}
              reload={() => this.onSearch()}
              onCreated={(data) => {
                this.showModalEdit(data, 1)
              }}
            />
          ) : (
            ''
          )}
        </Modal>
        {/* ////////////// END Modal ADD /////////// */}
        {/* ////////////// start Modal notification /////////// */}
        <Modal
          title="เพิ่มการแจ้งเตือน"
          key="modal-add-notification"
          open={this.state.showFormNotification}
          closable
          footer=""
          onCancel={this.hideModalNotification}
          bodyStyle={{
            padding: '5px',
            backgroundColor: '#ffffff',
            color: '#222222',
          }}
          style={{ top: 5 }}
          destroyOnClose
          // width={960}
        >
          {this.state.showFormNotification ? (
            <NotificationAdd
              hideModal={this.hideModalNotification}
              notificationType="CUSTOMER_POSTPONE"
              refId={this.state.editId}
            />
          ) : (
            ''
          )}
        </Modal>
        {/* ////////////// END Modal ADD /////////// */}
      </React.Fragment>
    )
  }
}

export default InformCard
